export default __webpack_public_path__ + "static/GradientOverlay-30d069eff0723cbaad9dcf1c8256cc88.png";